import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MicroModal from "micromodal";

import { InsertAnotations } from "../../../../actions";

import "./add-anotation-modal.css";

import { ReactComponent as ArrowLeft } from "../../../../build/images/arrow-left.svg";
import { ReactComponent as TickSquare } from "../../../../build/images/tick-square.svg";
import Typography from "../../../Typography";

export default function AddAnotationModal({ selectedChat }) {
  const dispatch = useDispatch();

  const InfoUsers = useSelector((state) => state.informationusers);
  const CriticidadesAnotacoes = useSelector((state) => state.criticalitys);

  const [buttonShowCriticitsIn, setButtonShowCriticitsIn] = useState(false);
  const [criticidadeSelec, setCriticidadeSelec] = useState("");
  const [descAnotacoes, setDescAnotacoes] = useState([]);
  const [idCriticidadeSelec, setIdCriticidadeSelec] = useState(0);
  const [iconeCriticidade, setIconeCriticidade] = useState("");
  const [noteComment, setNoteComment] = useState("");

  const SaveAnotation2 = (e, infoatendimento, infouser) => {
    const criticidade = idCriticidadeSelec;
    // const comentario = this.comentarioAnotacoes.value;
    const comentario = noteComment;
    let erro = 0;
    const userid = infouser.id;
    // const idcdr = this.state.idcdr;
    const idcdr = infoatendimento.idatendimento;
    const serviceAtdId =
      !!infoatendimento.serviceAtdId || infoatendimento.serviceAtdId === 0
        ? infoatendimento.serviceAtdId
        : "";

    if (criticidade === "") erro = 1;

    // if(comentario === '')
    //   var erro = 1

    if (userid === "") erro = 1;

    if (idcdr === "") erro = 1;

    if (erro === 0) {
      dispatch(
        InsertAnotations(idcdr, criticidade, comentario, userid, serviceAtdId)
      );
      MicroModal.close("modal__anotacoes-adicionar");
      setNoteComment("");
      MicroModal.show("modal__anotacoes-salvo");
    }

    if (buttonShowCriticitsIn === true)
      setButtonShowCriticitsIn(!buttonShowCriticitsIn);
    // this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  };

  useEffect(() => {
    if (CriticidadesAnotacoes.length !== 0) {
      let descAnot = CriticidadesAnotacoes.criticalitys;
      setDescAnotacoes(descAnot);
      // descAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (idCriticidadeSelec === 0) {
        // this.state.iconeCriticidade =
        //   descAnot[0].class_criticality;
        setIconeCriticidade(descAnot[0].class_criticality);
        // this.state.criticidadeSelec = descAnot[0].description;
        setCriticidadeSelec(descAnot[0].description);
        // idCriticidadeSelec = descAnot[0].id;
        setIdCriticidadeSelec(descAnot[0].id);
      }
    }
  }, [CriticidadesAnotacoes]);

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__anotacoes-adicionar"
        aria-hidden="true"
        role="dialog"
      >
        <div
          className="modal__overlay modal__overlay-add-anotation-modal"
          tabIndex="-1"
        >
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__anotacoes-adicionar__title"
          >
            <header className="modal__header">
              <ArrowLeft data-micromodal-close />
              <h2
                className="modal__title"
                id="modal__anotacoes-adicionar__title"
              >
                Adicionar anotações
              </h2>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__anotacoes-adicionar__content"
            >
              <div className="anotc-add">
                <div className="anotc-add__panel">
                  <p className="anotc-add__text">
                    Qual a criticidade dessa anotação?
                  </p>
                  <div className="anotc-add__critic-wrapper">
                    <button
                      onClick={(event) =>
                        setButtonShowCriticitsIn(!buttonShowCriticitsIn)
                      }
                      className="anotc-add__critic-btn"
                    >
                      {criticidadeSelec}
                      <i className="anotc-add-critic-icon material-icons">
                        keyboard_arrow_down
                      </i>
                    </button>
                    <div
                      className={
                        buttonShowCriticitsIn
                          ? "anotc-add__critic-options anotc-add__critic-options__drop-top active"
                          : "anotc-add__critic-options anotc-add__critic-options__drop-top"
                      }
                    >
                      <ul className="anotc__mp-critic-list">
                        {descAnotacoes.map((desc) => (
                          <li
                            className="anotc__mp-critic-item"
                            onClick={(event) => {
                              setButtonShowCriticitsIn(!buttonShowCriticitsIn);
                              setCriticidadeSelec(desc.description);
                              setIconeCriticidade(desc.class_criticality);
                              setIdCriticidadeSelec(desc.id);
                            }}
                          >
                            <span
                              className={
                                "anotc__mp-critic-dot " + desc.class_criticality
                              }
                            >
                              •
                            </span>{" "}
                            {desc.description}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="anotc-add__textarea">
                  <label
                    htmlFor="anotc-add__textarea__text"
                    className="anotc-add__textarea-label"
                  >
                    Descrição da anotação
                  </label>
                  <textarea
                    value={noteComment}
                    onChange={(e) => setNoteComment(e.target.value)}
                    name="anotc-add__textarea__text"
                    id="anotc-add__textarea__text"
                    className="anotc-add__textarea__text"
                  ></textarea>
                </div>
                <div className="anotc-add__actions">
                  <button
                    className="anotc-add__cancel-btn"
                    data-micromodal-close
                  >
                    <span>Cancelar</span>
                  </button>
                  <button
                    className="anotc-add__save-btn"
                    onClick={(event) =>
                      SaveAnotation2(event, selectedChat, InfoUsers)
                    }
                  >
                    <span>Salvar anotação</span>
                  </button>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>

      <div
        className="modal micromodal-slide"
        id="modal__anotacoes-salvo"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__anotacoes-salvo__title"
          >
            <header className="modal__header">
              <ArrowLeft
                onClick={() => MicroModal.show("modal__anotacoes-adicionar")}
                data-micromodal-close
              />
              <h2 className="modal__title" id="modal__anotacoes-salvo__title">
                Adicionar anotações
              </h2>
              <button
                className="modal__close"
                aria-label="Close modal"
                // onClick="toggleModal('modal__anotacoes')"
                data-micromodal-close
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__anotacoes-salvo__content"
            >
              <form action="" className="modal__content__form">
                <div className="modal__content__form__row">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content-center">
                      <div className="icon-center">
                        <TickSquare />
                      </div>

                      <Typography.H3 weight={700} color={"gray-600"}>
                        Sua anotação foi salva com sucesso!
                      </Typography.H3>
                    </div>
                  </div>
                </div>
              </form>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}
